import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser';
import UIAssetKeys from '../UIAssetKeys';

export default class JToggleButton extends Phaser.GameObjects.Container {
  /** @type {JToggleButton[]} */
  static _instances = [];

  static deselectAll (type) {
    const len = JToggleButton._instances.length;

    for (let i = 0; i < len; i++) {
      const thisOne = JToggleButton._instances[i];
      if (thisOne.type === type || type === null) {
        thisOne.deselect();
      }
    }
  }

  /**
   * 
   * @param {Phaser.Scene} scene 
   */
  constructor(scene, name, type = null) {
    super(scene);

    JToggleButton._instances.push(this);

    this.enabled = true;
    this.toggleOn = false;
    this.doAction = (sender) => {};

    this.name = name;
    this.type = type;

    if (name === UIAssetKeys._analog_clock) {
      this.selection = ABCyaPhaser.Images.addImage(0,-45,UIAssetKeys._Select_Analog, this);
    }
    else {
      this.selection = ABCyaPhaser.Images.addImage(0,-50,UIAssetKeys._Select_Digital, this);
    }
    this.selection.alpha = 0;

    this.sprite = ABCyaPhaser.Images.addImage(0,name === UIAssetKeys._analog_clock ? -42 : -50,name, this);
    this.sprite.alpha = 1;

    this.deselect();

    ABCyaPhaser.Container.setContainerInteractive(this, false);
    this.on(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, this.doClick, this);

    this.once(Phaser.GameObjects.Events.DESTROY, () => Phaser.Utils.Array.Remove(JToggleButton._instances, this));
  }

  doClick () {
    JToggleButton.deselectAll(this.type);

    this.toggleOn = true;

    this.selection.alpha = 1;

    this.emit('TOGGLE_ON');

    this.doAction(this);
  }

  deselect () {
    this.toggleOn = false;

    this.selection.alpha = 0;
  }
}